import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
import {Col, Row} from "react-bootstrap";
import parse from "html-react-parser";
import NavigationButtons from "../../Components/Layout/Elements/NavigationButtons";
import applicationSite from "../../assets/img/Sensor/application-site-selection-sm.png"
import './../../assets/css/Sensor/Sensor.css'
import ModalNote from "../../Components/Modal/ModalNote";
import {HiExclamationTriangle} from "react-icons/hi2";
import {CiCircleInfo} from "react-icons/ci";
import video from './../../assets/videos/remove-sensor-sm.mp4'
import {Link} from "react-router-dom";
import Video from "../../Components/Layout/Elements/VideoPlayer";
const RemovingSensor = () => {
    const {t, i18n} = useTranslation()
    const [show, setShow] = useState(false);
    const [title, setTitle] = useState()
    const [text, setText] = useState()
    const lang = localStorage.getItem('lang');

    const videoRef = useRef(null);



    const handleClose = () => {
        setShow(false)
    }
    return (
        <>
            <Col md={6} className={'text-start ps-4'}>

                <h2> {t("removingSensor")}</h2>


                <p className={''}>
                    <span>{parse(t("removingSensor_Text"))}  </span>
                </p>


                <p className={'text-orange fw-bold mb-0 mt-2'}> {t("howTo")}</p>

                <hr className={'text-orange my-1 opacity-100 mb-3'}/>
                <p className={'mb-3 d-flex align-items-center justify-content-between'}>
                    <span>{parse(t('removingSensor_List_1'))}  </span>
                    <span>
                         <CiCircleInfo className={'fs-3 ms-2 text-end text-orange'} onClick={() => {
                             setShow(true)
                             setTitle(t('note'))
                             setText(t('removingSensor_Info'))
                         }}/>
                    </span>
                </p>
                <hr className={'text-orange my-1 opacity-100 mb-3'}/>
                <p className={'mb-3 d-flex align-items-center justify-content-between'}>
                    <span>{parse(t("removingSensor_List_2"))}  </span>


                </p>
            </Col>
            <Col md={6} className={''}>

                {video && <Video video={video} t={t} videoRef={videoRef}  />}
            </Col>
            <Col md={12} className={'text-start align-self-end'}>
                <NavigationButtons t={t} prevUrl={'/applying-sensor'} nextUrl={'/starting-sensor'}/>
            </Col>
            <ModalNote show={show} handleClose={handleClose} text={text} title={title}></ModalNote>
        </>


    )
}

export default RemovingSensor